import Body from "./components/Body";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function App() {
  return (
    <div className="bg-[#fff6ef] min-h-screen font-serif">
      <Body />
    </div>
  );
}

export default App;
